import BloomSpacePhoneSvg from '@assets/images/svg/bloom-space-phone.svg';
import { getColors } from '@/core/constants/uiColors';
import React from 'react';
import { StyleSheet, View } from 'react-native';

const bloomColors = getColors();

export interface BloomSpacePhoneIconProps {
  readonly size?: number;
  readonly color?: string;
}

/**
 * Figma call-button phone for Bloom Universal space pages.
 * Separate from shared `PhoneIcon` / `phone.svg`.
 */
export function BloomSpacePhoneIcon({
  size = 22,
  color = bloomColors.bloomUniversalInkStrong,
}: Readonly<BloomSpacePhoneIconProps>) {
  return (
    <View style={[styles.wrap, { width: size, height: size }]}>
      <BloomSpacePhoneSvg width={size} height={size} color={color} />
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default BloomSpacePhoneIcon;
